exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app-home{background-color:#e8e6e1;height:100vh}.app-home,.app-home__top-bar{display:flex;flex-direction:column}@media only screen and (min-width:720px){.app-home__top-bar{width:400px}}", ""]);

